import React, { useEffect } from "react";
import NavBar from "../../../../components/navbar/NavBar";
import useLocalWallet from "../../../../utils/hooks";
import "../../../promotional/TableRecord.css";
import useContractInit from "../../../../utils/hooks/contractInit";
import { Link } from "react-router-dom";

const AdminInitializationHistory = () => {
  const { isOpen } = useLocalWallet();
  const { tokenQuantity, slotReleaseDate, getTokenInitializationDetails } =
    useContractInit();

  useEffect(() => {
    getTokenInitializationDetails();
  }, []);

  const hasData = tokenQuantity && Object.keys(tokenQuantity).length > 0;

  return (
    <>
      <NavBar />
      <div className={`sidebar-sec ${isOpen === true ? "active" : ""}`}>
        <section id="content-wrapper" className="contract-nitialization-page">
          <h4 className="my-dash main-head Contract-Initialization-Details">
            Contract Initialization Details
          </h4>
          <div className="flex justify-center items-center min-h-screen bg-gray-100">
            {hasData ? (
              <div className="overflow-x-auto">
                <table className="w-100 border-collapse border border-gray-400">
                  <thead>
                    <tr className="bg-orange-500 text-white">
                      <th className=" border-black-400  table-header adminitialization-heading">
                        S.No
                      </th>
                      <th className=" border-black-400  table-header adminitialization-heading">
                        Date of token release
                      </th>
                      <th className="border border-black-400 table-header adminitialization-heading">
                        Quantity of Tokens Release
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.keys(tokenQuantity).map((key) => (
                      <tr key={key} className="bg-gray-50 hover:bg-gray-200">
                        <td className="border border-white-400 px-4 py-2 text-center adminitialization">
                          {key} month
                        </td>
                        <td className="border border-black-400 px-4 py-2 text-center adminitialization">
                          {new Date(slotReleaseDate[key] * 1000).toLocaleString(
                            "en-US",
                            {
                              month: "2-digit",
                              day: "2-digit",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit",
                              hour12: false,
                            }
                          )}
                        </td>
                        <td className="border border-white-400 px-4 py-2 text-center adminitialization">
                          {tokenQuantity[key]}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center text-gray-500 init-nodata">
                <h4>Contract not initialized yet</h4>
                <p>
                  You can Initialize the contract from
                  <Link
                    to="/admin-token-initialize"
                    className="link-to-contract"
                  >
                    Contract Initialization
                  </Link>
                  tab.
                </p>
                <p className="contract-init-p">
                  Note: Make sure you have created and minted token before
                  initializing the contract
                </p>
              </div>
            )}
          </div>
        </section>
      </div>
    </>
  );
};

export default AdminInitializationHistory;
